/**
 * Let's us reference the roles that we use in our application for security. As properties of this
 * interface rather than as magic strings everywhere.
 */
export interface IApplicationRoles {
  readonly byuiAdmin: string;
  readonly byuiLeader: string;
}

/**
 * The actual values of the application security roles in our system.
 */
export const ApplicationRoles: IApplicationRoles = {
  byuiAdmin: 'Admin',
  byuiLeader: 'Leader'
};
